export enum TicketRequestStatus {
  Approved = 'approved',
  Declined = 'declined',
  Pending = 'pending',
  Delivered = 'delivered',
}
